module.exports = __webpack_public_path__ + "static/media/focus-icon-2.24218f3f.webp";